import { NgModule } from '@angular/core';

// Cerium applicaiton module
import { CerAppModule } from 'src/cer-app/cer-app.module';

// Main app
import { HomeComponent } from '@core/home/home.component';
import { MailTemplateComponent } from '@core/mail/mail-template/mail-template.component';
import { UserRoleComponent } from '@core/user/user-role/user-role.component';
import { UserIdentityComponent } from '@core/user/user-identity/user-identity.component';

var appCoreDeclarations = [
  HomeComponent,
  MailTemplateComponent,
  UserRoleComponent,
  UserIdentityComponent
]

var appCoreImports = [
  CerAppModule,
]

var appCoreProviders : any[] = [
]

var appCoreExports = [].concat(appCoreDeclarations).concat(appCoreImports);

@NgModule({
  declarations: appCoreDeclarations,
  imports: appCoreImports,
  providers: appCoreProviders,
  exports: appCoreExports
})
export class AppCoreModule { }
